import type { GeoLightingManager } from '../geo-lighting-manager.class';
import type { OriginalLightState } from '../types';

/**
 * Store original light states before enabling geo lighting
 */
export const storeOriginalLightStateCfn = (
	self: GeoLightingManager
): OriginalLightState => {
	const { ambientLight, directionalLight, hemisphereLight } = self.configAccess;
	const state: OriginalLightState = {};

	if (ambientLight) {
		state.ambient = {
			color: ambientLight.color.getHex(),
			intensity: ambientLight.intensity
		};
	}

	if (directionalLight) {
		state.directional = {
			color: directionalLight.color.getHex(),
			intensity: directionalLight.intensity,
			position: directionalLight.position.clone()
		};
	}

	if (hemisphereLight) {
		state.hemisphere = {
			skyColor: hemisphereLight.color.getHex(),
			groundColor: hemisphereLight.groundColor.getHex(),
			intensity: hemisphereLight.intensity
		};
	}

	return state;
};

/**
 * Restore original light states
 */
export const restoreOriginalLightStateCfn = (
	self: GeoLightingManager
): void => {
	const { ambientLight, directionalLight, hemisphereLight } = self.configAccess;
	const originalState = self.originalLightState;

	if (ambientLight && originalState.ambient) {
		ambientLight.color.setHex(originalState.ambient.color);
		ambientLight.intensity = originalState.ambient.intensity;
	}

	if (directionalLight && originalState.directional) {
		directionalLight.color.setHex(originalState.directional.color);
		directionalLight.intensity = originalState.directional.intensity;
		directionalLight.position.copy(originalState.directional.position);
	}

	if (hemisphereLight && originalState.hemisphere) {
		hemisphereLight.color.setHex(originalState.hemisphere.skyColor);
		hemisphereLight.groundColor.setHex(originalState.hemisphere.groundColor);
		hemisphereLight.intensity = originalState.hemisphere.intensity;
	}
};
